import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIResponse } from "src/app/core/models/api-response";
import { IBrand } from "../models/brands.models";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { IPageCount } from "src/app/shared/models/page.model";

@Injectable({
  providedIn: 'root',
})
export class BrandsService {

  constructor(private http: HttpClient) { }

  public listAllBrands(includes?: Array<string>): Observable<APIResponse<IBrand>> {
    let params = new HttpParams();
    if (includes) {
      params = params.set('includes', includes.join(','));
    }
    return this.http.get<APIResponse<IBrand>>(`${environment.BASE_URL_API}brands`, { params });
  }

  public listBrands(page: IPageCount, key?:string): Observable<APIResponse<IBrand>> {
    const params = new HttpParams()
    .set('page', page.number)
    .set('limit', page.size)
    .set('key', key ?? '');
    return this.http.get<APIResponse<IBrand>>(environment.BASE_URL_API + 'brands', { params });
  }

  public addBrand(brand: Omit<IBrand, 'id'>): Observable<APIResponse<IBrand>> {
    return this.http.post<APIResponse<IBrand>>(
      environment.BASE_URL_API + 'brand',
      brand
    );
  }

  public updateBrand(id: number, brand: Omit<IBrand, 'id'>): Observable<APIResponse<IBrand>> {
    return this.http.post<APIResponse<IBrand>>(
      environment.BASE_URL_API + 'brand/' + id,
      brand
    );
  }

  public deleteBrand(id: number): Observable<APIResponse<IBrand>> {
    return this.http.delete<APIResponse<IBrand>>(
      environment.BASE_URL_API + 'brand/' + id,
    );
  }
}
